import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexRow)`
    align-items: center;
`;

export const Chip = styled.div`
    display: inline-block;
    margin-left: 4px;
    padding: 4px 6px;
    border-radius: 8px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    background-color: ${colorsPalettes.carbon[50]};
    ${setFontVariant("tag", colorsPalettes.carbon[300])};
`;
